import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { getUserError, getUserStatus } from "../store/slices/userSlice";
import $ from "jquery";
import "datatables.net";
import Modal from "react-modal";
import { getSeasonRankings } from "../store/featureActions";
import ImageViewer from "react-simple-image-viewer";
import { useNavigate, useParams } from "react-router-dom";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    width: "30%",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    border: "0px",
    padding: "0px",
  },
};
Modal.setAppElement("#root");
const PlayersRanking = () => {
  const { _id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [rankingUsers, setRankingUsers] = useState(null);
  const status = useSelector(getUserStatus);
  const error = useSelector(getUserError);
  const [userDetail, setUserDetail] = useState(null);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalType, setModalType] = useState();
  const [modalImages, setmodalImages] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const openImageViewer = useCallback((images, index) => {
    setCurrentImage(index);
    setmodalImages(images);
  }, []);
  function viewModal(item, type) {
    setIsOpen(true);
    if (type == "userDetail") {
      setUserDetail(item);
    }
    setModalType(type);
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
    setCurrentImage(0);
    setmodalImages(false);
  }

  const getRankingUsers = async () => {
    try {
      setRankingUsers(null);
      let payload = {
        params: _id,
        isToast: false,
      };
      const response = await dispatch(getSeasonRankings(payload)).unwrap();
      setRankingUsers(response?.data?.data);
    } catch (rejectedValueOrSerializedError) {
      console.log(rejectedValueOrSerializedError);
    }
  };

  useEffect(() => {
    let mount = true;
    if (mount) {
      getRankingUsers();
    }
    return () => {
      mount = false;
    };
  }, []);

  useEffect(() => {
    if (rankingUsers) {
      $("#tableData").DataTable({
        lengthMenu: [10, 25, 50, 100, 200],
        language: {
          emptyTable: "Users Not Found",
        },
        destroy: true,
      });
    }
  }, [rankingUsers]);

  return (
    <>
      <Modal closeTimeoutMS={500} isOpen={modalIsOpen} onRequestClose={closeModal} style={customStyles} contentLabel="Change Password">
        <div className="change-password-modal" id="exampleModalCenter" tabIndex={-1} aria-labelledby="exampleModalCenterTitle" aria-hidden="true" style={{ display: "block", zIndex: 100 }}>
          {modalType == "userDetail" ? (
            <>
              <div className="headerModal">
                <p className="pass-text">User Detail</p>
                <button onClick={closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body">
                <p className="modal_inner_img" onClick={() => openImageViewer([userDetail?.imageName], 0)}>
                  <span>
                    <img height="20%" width="20%" style={{ borderRadius: 5 }} src={userDetail?.imageName ? `${userDetail?.imageName}` : "assets/images/placeholder.jpg"} />
                  </span>
                </p>
                <p className="user_detail">
                  <b>Name:</b> {userDetail?.name ? userDetail?.name : "N/A"}
                </p>
                <p className="user_detail">
                  <b>User Name:</b> {userDetail?.userName ? userDetail?.userName : "N/A"}
                </p>
                <p className="user_detail">
                  <b>Bio:</b> {userDetail?.bio ? userDetail?.bio : "N/A"}
                </p>
                <p className="user_detail">
                  <b>Device Type:</b> {userDetail?.user_device_type ?  userDetail.user_device_type.charAt(0).toUpperCase() + userDetail.user_device_type.slice(1) : "N/A"}
                </p>
                <p className="user_detail">
                  <b>Notification:</b> {userDetail?.notification.charAt(0).toUpperCase() + userDetail?.notification.slice(1)}
                </p>
                <p className="user_detail">
                  <b>Last Login:</b> {moment(userDetail?.lastLogin).local().format("MM-DD-YYYY hh:mm A")}
                </p>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      </Modal>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          marginTop: rankingUsers ? "1%" : "12%",
        }}
      >
        <section className="coupon-sec-2">
          <div className="container tableContainer">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-12">
                <div className="card shadow mb-4">
                  <div className="card-body">
                    <div className="table-responsive" id="tableready">
                      <table id="tableData" className="table table-bordered display" style={{ width: "100%", textAlign: "center" }}>
                        <thead>
                          {rankingUsers ? (
                            <tr>
                              <th>S.No</th>
                              <th>Player Id</th>
                              <th>Name</th>
                              <th>User Name</th>
                              <th>Email</th>
                              <th>Global Rank</th>
                              <th>Joined date</th>
                              <th>Stats</th>
                              <th>Detail</th>
                            </tr>
                          ) : (
                            <tr></tr>
                          )}
                        </thead>
                        <tbody>
                          {rankingUsers?.map((item, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{`ReelRivals-${item?.userId?.id}-${moment().format("YYYY")}`}</td>
                              <td>{item?.userId?.name}</td>
                              <td>{item?.userId?.userName}</td>
                              <td>{item?.userId?.user_social_token ? "Social User" : item?.userId?.email}</td>
                              <td>{i + 1}</td>
                              <td>{moment(item?.createdAt).format("DD-MMM-YYYY")}</td>
                              <td>
                                <span className="edit-icon">
                                  <span style={{ cursor: "pointer", fontWeight: "bold", margin: 10, fontSize: 13 }} onClick={() => navigate("/quick-stats", { state: { item: item, type: "season" } })}>
                                    View
                                  </span>
                                </span>
                              </td>
                              <td>
                                <span className="edit-icon">
                                  <span style={{ cursor: "pointer", fontWeight: "bold", margin: 10, fontSize: 13 }} onClick={() => viewModal(item?.userId, "userDetail")}>
                                    <i className="fas fa-eye"></i>
                                  </span>
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        {!rankingUsers ? (
                          status == "loading" || error ? (
                            <tfoot>
                              <tr>
                                <th>{status == "loading" ? "Loading..." : error ? error : ""}</th>
                              </tr>
                            </tfoot>
                          ) : (
                            <></>
                          )
                        ) : (
                          <></>
                        )}
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {modalImages && (
          <ImageViewer
            src={modalImages}
            currentIndex={currentImage}
            onClose={closeModal}
            disableScroll={true}
            backgroundStyle={{
              backgroundColor: "rgba(0,0,0,0.9)",
              zIndex: 3,
            }}
            closeOnClickOutside={true}
            showPrevButton={currentImage > 0}
          />
        )}
      </div>
    </>
  );
};
export default PlayersRanking;
